// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchFaultType {
constructor({
        id = null,
        parentId = '',
        name = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchFaultType();
}

function gridFields() {
return Object.freeze([
        {
        key: 'level',
        label: 'label.em.archive.emArchFaultType.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.archive.emArchFaultType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.archive.emArchFaultType.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchFaultType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
]);
}

const filter = {
    parentIdFilter : "",
    levelFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'parentIdFilter',
        label: 'label.em.archive.emArchFaultType.filter.parentId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchFaultType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.em.archive.emArchFaultType.filter.level',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.archive.emArchFaultType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'parentId',
        label: 'label.em.archive.emArchFaultType.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchFaultType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'name',
        label: 'label.em.archive.emArchFaultType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'seq',
        label: 'label.em.archive.emArchFaultType.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchFaultType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmArchFaultType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
